import React from 'react'
import { makeStyles } from 'tss-react/mui'
import Banner from 'src/Components/banner/Banner'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'
import { J2Caution } from '@e3dc-react/icons'
import { Box } from '@mui/material'

const useStyles = makeStyles()(theme => ({
  container: {
    backgroundColor: theme.palette.warning.light,
  },
}))

/**
 * Banner shown in the root of e-mobility section. It is shown in the rare cases when the network request sent to the
 * new e-mobility backend(HagerBridge) fails while fetching information if this installation was migrated to the new
 * backend and if we can show the new frontend.
 *
 * Once all installations are migrated and the old e-mobility code is deleted, this banner component can also be deleted.
 */
export const NewEMobilityUnavailableBanner: React.FC = (): JSX.Element => {
  const { classes } = useStyles()

  return (
    <Box mb={2}>
      <Banner
        bannerKey={BannerKey.EmobilityNewBackendUnavailableBanner}
        i18nKey="emobility.new-e-mobility-unavailable-banner-text"
        closeType={BannerCloseTypes.permanentOrTemporary}
        icon={<J2Caution color="warning" />}
        containerStyle={classes.container}
      />
    </Box>
  )
}
